// extracted by mini-css-extract-plugin
module.exports = {"productGrid":"fh","centerLink":"gh","productSection":"hh","item":"ih","ctaButton":"jh"};